import React from 'react';
import Image from 'next/image';

interface FinancingCardProps {
    title: string;
    subtitle?: string | null;
    logo?: string | null;
    description?: string | null;
    buttonText?: string | null;
    buttonUrl?: string | null;
}

export const FinancingCard: React.FC<FinancingCardProps> = ({
    title,
    subtitle,
    logo,
    description,
    buttonText,
    buttonUrl,
}) => {
    const buttonContent = (
        <>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM4.75 7.25C4.33579 7.25 4 7.58579 4 8C4 8.41421 4.33579 8.75 4.75 8.75L9.43934 8.75L8.21967 9.96967C7.92678 10.2626 7.92678 10.7374 8.21967 11.0303C8.51256 11.3232 8.98744 11.3232 9.28033 11.0303L11.7803 8.53033C12.0732 8.23744 12.0732 7.76256 11.7803 7.46967L9.28033 4.96967C8.98744 4.67678 8.51256 4.67678 8.21967 4.96967C7.92678 5.26256 7.92678 5.73744 8.21967 6.03033L9.43934 7.25L4.75 7.25Z" fill="#1B365E" />
            </svg>
            {buttonText}
        </>
    );

    return (
        <div className="bg-white rounded-lg border border-[#ABABAB] px-5 pt-4 pb-[19px] w-full flex flex-col h-full min-h-[320px] transition-shadow">
            <div className="flex-grow ">
                <div className="">
                    <h3 className="text-[16px] leading-6.5 tracking-[0.2px] font-bold text-[#1B365E] mb-1">
                        {title}
                    </h3>
                    {subtitle && (
                        <p className="text-[12px] leading-5 tracking-[0.2px] font-normal text-[#1B365E]">
                            {subtitle}
                        </p>
                    )}
                </div>

                {logo && (
                    <div className="flex items-center mb-1 h-[61px]">
                        <Image
                            src={logo}
                            alt={title}
                            loading="lazy"
                            width={123}
                            height={61}
                            className="w-[123px] object-contain"
                        />
                    </div>
                )}

                {description && (
                    <p className="text-[12px] leading-5 tracking-[0.2px] font-normal text-[#1D1D1D] border-b border-[#D9D9D9] pb-3">
                        {description}
                    </p>
                )}
            </div>

            {buttonUrl ? (
                <a
                    href={buttonUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full cursor-pointer flex items-center justify-center gap-2 text-[14px] sm:text-[15px] text-[#1B365E] font-bold hover:opacity-80 transition-opacity mt-4"
                >
                    {buttonContent}
                </a>
            ) : (
                <button className="w-full cursor-pointer flex items-center justify-center gap-2 text-[14px] sm:text-[15px] text-[#1B365E] font-bold hover:opacity-80 transition-opacity mt-4">
                    {buttonContent}
                </button>
            )}
        </div>
    );
};
